import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { BDataGrid } from '../common/dataGrid/BDataGrid';
import SpendingsActionCreator from '../../actions/SpendingsActionCreator';
import SpendingsStore from '../../stores/SpendingsStore';
import config from '../../config';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import moment from 'moment';
import BrowserUtils from '../../utils/BrowserUtils';
import SpendingsHeaderProgress from './SpendingsHeaderProgress';
import { BudgetTableRowTemplate } from './BudgetTableRowTemplate';
import { BudgetTableRowTemplateMobile } from './BudgetTableRowTemplate_Mobile';
import UntaggedPage from './UntaggedPage';

class BudgetScreen extends PureComponent {
  static propTypes = {
    content: PropTypes.object,
    budgetData: PropTypes.array,
    totalCurrentMonthValue: PropTypes.string,
    isNoBudget: PropTypes.bool,
    allBudgetTarget: PropTypes.array,
    _detailedScreen: PropTypes.func,
  };
  state = {
    getAllAccountIds: SpendingsStore.updatedAccountIds(),
  };
  componentDidMount() {
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/view',
        action: 'Appeared',
      },
      {
        description: config.analytics.analytics_name_bos_budget,
      }
    );
  }
  onRowClick = (e, item) => {
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_name_spend_view_transaction_tag,
        event: 'click',
      }
    );
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth();
    const firstDay = new Date(y, m, 1);
    const tagId = item.key.toString();
    const tagName = item.name;
    let filter_field;
    if (item.tag_budget || item.archived || item.joint) {
      filter_field = 'metadata.tags.id';
    } else {
      filter_field = 'metadata.categories.id';
    }
    const requestDataTemplate = {
      name: tagName,
      filter_value: tagId,
      filter_field,
      order: 'desc',
      size: 25,
      sort_field: 'details.when',
      start_date: moment(firstDay).format('YYYY-MM-DDTHH:mm:ss.[000+0100]'),
    };
    SpendingsActionCreator.getTransactionDetails(requestDataTemplate);
  };
  totalDaysLeft = () => {
    const currentDate = moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY');
    const lastDateOfTheMonth = moment(
      moment().endOf('month').format('DD/MM/YYYY'),
      'DD/MM/YYYY'
    );
    return lastDateOfTheMonth.diff(currentDate, 'days');
  };
  render() {
    const content = this.props.content;
    const budgetData = this.props.budgetData;
    const totalCurrentMonthValue = this.props.totalCurrentMonthValue;
    const allBudgetTarget = this.props.allBudgetTarget;

    const budgetAmount = _.sum(allBudgetTarget);
    let budgetAmountInt;
    let untaggedData;

    if (_.isInteger(budgetAmount)) {
      budgetAmountInt = budgetAmount;
    } else {
      budgetAmountInt = budgetAmount.toFixed(2);
    }

    let leftValue;
    let rightValue;
    let labelLeft;
    let labelRight;

    labelLeft = content.spendingHeaderThisMonthText;
    labelRight = content.spendingHeaderBudgetText;
    leftValue = Number(totalCurrentMonthValue);
    rightValue = Number(budgetAmountInt);

    let budgetScreenDesktop;
    let budgetScreenMobile;
    let budgetScreenMobileRows;
    if (!BrowserUtils.isMobileView()) {
      budgetScreenDesktop = (
        <span>
          <SpendingsHeaderProgress
            content={content}
            isNoBudget={this.props.isNoBudget}
            leftValue={leftValue}
            rightValue={rightValue}
            labelLeft={labelLeft}
            labelRight={labelRight}
          />

          <div className="spendings-month">
            <div className="spendings-grid spendings content-wrapper oldTable">
              <BDataGrid
                results={budgetData}
                columns={[
                  'name',
                  'current_month',
                  'progress',
                  'target_amount',
                  'message',
                ]}
                columnMetadata={columnMeta}
                initialSortAscending={false}
                customClick={this.onRowClick}
                initialSort="current_month"
                enableInfiniteScroll={false}
                useCustomPagerComponent="false"
                showPager={false}
                useFixedHeader
                resultsPerPage={budgetData.length}
                bodyHeight={400}
                content={this.props.content}
                showNoData
                noDataMessage={content.spendingTableLoading}
                tableClassName="table"
              />
            </div>
          </div>
        </span>
      );
    } else {
      const matchedUntaggedData = _.find(budgetData, { name: 'Untagged' });
      const budgetDataSorted = _.sortBy(budgetData, ['name']);

      const indexOfUntaggedData = budgetDataSorted.indexOf(matchedUntaggedData);
      const untaggedDataPart = budgetDataSorted.splice(indexOfUntaggedData, 1);

      untaggedData = untaggedDataPart.map((item, index) => {
        return (
          <UntaggedPage
            rowData={item}
            customClick={this.onRowClick}
            content={this.props.content}
            key={`untaggedData_untaggedDataPart_UntaggedPage_${index}`}
          />
        );
      });
      const budgetDataSortedFinal = _.sortedUniq(budgetDataSorted);
      budgetScreenMobileRows = budgetDataSortedFinal.map((item, index) => {
        return (
          <BudgetTableRowTemplateMobile
            rowData={item}
            customClick={this.onRowClick}
            content={this.props.content}
            key={`budgetScreenMobileRows_budgetDataSortedFinal_BudgetTableRowTemplateMobile_${index}`}
          />
        );
      });

      budgetScreenMobile = (
        <div className="full-height spendings-budget">
          <div className="row no-gutters header-row">
            <div className="col-xs-6">
              <button
                className="page-back"
                id="0"
                type="button"
                onClick={this.props._detailedScreen}
              >
                <span className="icon icon-page-back" />
                {this.props.content.back}
              </button>
            </div>
            <div className="col-xs-12 text-center">
              <h5>This month vs Budget</h5>
            </div>
          </div>
          <div className="calendar-row budget-calendar">
            <section className="full-row text-center">
              <h5>
                <span className="icon icon-calendar" />
                <b>{this.totalDaysLeft()}</b> {content.spendingDaysLeftText}
              </h5>
            </section>
          </div>
          {untaggedData}
          <div className="scroll-wrapper">{budgetScreenMobileRows}</div>
        </div>
      );
    }
    return BrowserUtils.isMobileView() ? (
      <div className="full-height">{budgetScreenMobile}</div>
    ) : (
      <div className="full-height">{budgetScreenDesktop}</div>
    );
  }
}

const columnMeta = [
  {
    columnName: 'name',
    order: 1,
    locked: false,
    visible: true,
    displayName: 'Tag',
    sortable: true,
    sortDirectionCycle: ['desc', 'asc'],
    customComponent: BudgetTableRowTemplate,
    freeze: 'Untagged',
    cssClassName: 'column-tag',
  },
  {
    columnName: 'current_month',
    order: 2,
    locked: false,
    visible: true,
    displayName: 'Spent this month',
    sortable: true,
    customComponent: BudgetTableRowTemplate,
    cssClassName: 'column-spent',
  },
  {
    columnName: 'progress',
    order: 3,
    locked: false,
    visible: true,
    displayName: ' ',
    sortable: false,
    customComponent: BudgetTableRowTemplate,
    cssClassName: 'column-progress',
  },
  {
    columnName: 'target_amount',
    order: 4,
    locked: false,
    visible: true,
    displayName: 'Amount Budgeted',
    sortable: true,
    customComponent: BudgetTableRowTemplate,
    cssClassName: 'column-amount',
  },
  {
    columnName: 'message',
    order: 5,
    locked: false,
    visible: true,
    displayName: 'Status',
    sortable: false,
    customComponent: BudgetTableRowTemplate,
    cssClassName: 'column-status',
  },
];

export default BudgetScreen;
